__turbopack_context__.v({
  "centered": "PageHeader-module-scss-module__b5xQUq__centered",
  "coverPhoto": "PageHeader-module-scss-module__b5xQUq__coverPhoto",
  "hero": "PageHeader-module-scss-module__b5xQUq__hero",
  "pageheader": "PageHeader-module-scss-module__b5xQUq__pageheader",
  "pageheaderlinks": "PageHeader-module-scss-module__b5xQUq__pageheaderlinks",
  "pageheadermeta": "PageHeader-module-scss-module__b5xQUq__pageheadermeta",
  "spacer": "PageHeader-module-scss-module__b5xQUq__spacer",
});
